 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      User Helplist
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryUserFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryUserFilterForm"
                            v-model="filtersUser.id"
                            :label="filtersUserLabel.usrId"
                            :error-messages="errors.collect('filterUsrId')"
                            data-vv-name="filterUsrId"
                            :data-vv-as="filtersUserLabel.usrId"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryUserFilterForm"
                            v-model="filtersUser.usrRefId"
                            :label="filtersUserLabel.usrRefId"
                            :error-messages="errors.collect('filterUsrRefId')"
                            data-vv-name="filterUsrRefId"
                            :data-vv-as="filtersUserLabel.usrRefId"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryUserFilterForm"
                            v-model="filtersUser.firstName"
                            :label="filtersUserLabel.firstName"
                            :error-messages="errors.collect('filterFirstName')"
                            data-vv-name="filterFirstName"
                            :data-vv-as="filtersUserLabel.firstName"
                            v-validate="'entry|max:128'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearUserFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doUserFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="userHeaders"
          :items="userItems"
          v-bind:options.sync="paginationUser"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.usrId }}</td>
              <td>{{ row.item.usrRefId }}</td>
              <td>{{ row.item.firstName }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignUser(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersUserLabel: {
        usrId: 'User ID',
        usrRefId: 'User Ref ID',
        firstName: 'First Name'
      },
      filtersUser: {
        id: null,
        firstName: undefined,
        usrRefId: undefined
      },
      userItems: [],
      totalItems: 0,
      userHeaders: [
        { text: 'User ID', align: 'left', value: 'usrId' },
        { text: 'User Ref ID', align: 'left', value: 'usrRefId' },
        { text: 'First Name', align: 'left', value: 'firstName' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationUser: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    'paginationUser': function (value) {
      this.fetchUserData()
    }
  },
  mounted() {
    this.doClearUserFilters()
  },
  methods: {
    closeDialog() {
      this.filtersUser.id = ''
      this.filtersUser.firstName = ''
      this.filtersUser.usrRefId = ''
      this.$emit('close')
    },
    doClearUserFilters() {
      this.filtersUser.id = ''
      this.filtersUser.firstName = ''
      this.filtersUser.usrRefId = ''
      this.fetchUserData()
    },
    doUserFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryUserFilterForm').then((result) => {
        if (result) {
          this.paginationUser.page = 1
          this.fetchUserData()
        }
      })
    },
    assignUser(data) {
      this.$emit('assign-user', data)
      this.$emit('close')
      this.doClearUserFilters()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
